/* Rodier dots navigation */
(function() {
  function initDots(themeScroll) {
    /* multicolumn: scroll on .multicolumn--inner, slides = .multicolumn--column */
    /* carousel: scroll on .products.carousel, slides = .carousel__slide */
    var inner = themeScroll.querySelector('.multicolumn--inner') ||
                themeScroll.querySelector('.products.carousel');
    if (!inner) return;
    var slides = Array.from(inner.querySelectorAll(
      inner.classList.contains('multicolumn--inner') ? '.multicolumn--column' : '.carousel__slide'
    ));
    if (!slides.length) return;

    var dotsEl = document.createElement('div');
    dotsEl.className = 'multicolumn-dots';

    slides.forEach(function(_, i) {
      var dot = document.createElement('button');
      dot.className = 'multicolumn-dots__dot';
      dot.setAttribute('aria-label', 'Slide ' + (i + 1));
      dot.addEventListener('click', function() {
        inner.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      });
      dotsEl.appendChild(dot);
    });

    themeScroll.insertAdjacentElement('afterend', dotsEl);

    function updateDots() {
      var active = Math.round(inner.scrollLeft / inner.offsetWidth);
      dotsEl.querySelectorAll('.multicolumn-dots__dot').forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === active);
      });
    }

    inner.addEventListener('scroll', updateDots, { passive: true });
    updateDots();
  }

  /* multicolumn dots */
  document.querySelectorAll('.multicolumn--dots-nav theme-scroll').forEach(initDots);
  /* product reco / recently viewed dots */
  document.querySelectorAll('theme-scroll.rodier-dots-nav').forEach(initDots);
})();

/* Sizing guide drawer — move to body to escape stacking context */
document.querySelectorAll('.sizing-guide-drawer').forEach(function(drawer) {
	document.body.appendChild(drawer);
});

document.addEventListener('click', function(e) {
	var btn = e.target.closest('[data-sizing-drawer]');
	if (!btn) return;
	var drawer = document.querySelector(btn.dataset.sizingDrawer);
	if (!drawer) return;
	drawer.classList.add('active');
	drawer.removeAttribute('inert');
	drawer.removeAttribute('aria-hidden');
	document.body.classList.add('open-cc', 'overflow-hidden');
});